import React, { useMemo } from 'react';
import { HolidayActivityFill } from "./WallPlannerActivityBlocks";
import { daysBetween } from '@shared/utils/DateUtils';
import moment, { Moment } from "moment";
import { PopupPosition } from "./HolidayInfoAndApprovalPopup";
import Icon, { IconTypes } from '@shared/ui/atoms/icon/Icon';
import styled from "styled-components";
import Colours from '@shared/ui/atoms/Colours';
import { CompanyHoliday } from '@features/holidays/services/CompanyHolidayService';
import { CompanyHolidayInfoPopup } from "./CompanyHolidayInfoPopup";
import { Birthday } from '@shared/models/user.models';
import { useFillHover } from "./useFillHover";

export function CompanyHolidayBlock(props: Props) {
  const {activity, firstDateOnCalendar} = props;
  const days = 1;
  const hover = useFillHover();

  const popupPositioning = useMemo(() => {
    const daysDiff = moment(activity.date).diff(firstDateOnCalendar, 'days');
    return daysDiff > 20 ? PopupPosition.Right : PopupPosition.Left;
  }, [activity, firstDateOnCalendar]);

  return (
    <HolidayActivityFill ref={hover.ref}
                         start={daysBetween(activity.date, firstDateOnCalendar)}
                         days={days}
                         fill={Colours.veryLightGrey}
                         outline={'#A6B4B4'}
                         textColour={Colours.black}
                         {...hover.triggerProps}
                         title={activity.label}>
      <Contents>
        <Icon icon={IconTypes.Flag} />
        {props.children && <>{props.children}</>}
      </Contents>
      <CompanyHolidayInfoPopup companyHoliday={activity}
                               popupPositioning={popupPositioning}
                               isVisible={hover.visible}
                               triggerRect={hover.rect}
                               onMouseEnter={hover.popupProps.onMouseEnter}
                               onMouseLeave={hover.popupProps.onMouseLeave} />
    </HolidayActivityFill>
  )
}

interface Props {
  activity: CompanyHoliday;
  children?: any;
  firstDateOnCalendar: Moment;
  weeksInMonth: number;
  birthday?: Birthday;
}

const Contents = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  overflow: hidden;
`
